export default function sendGTMEvent(
  value: Record<string, unknown> | unknown[],
) {
  if (typeof window === 'undefined') return;

  if (typeof window.dataLayer === 'undefined') {
    setTimeout(() => sendGTMEvent(value), 100);
    return;
  }

  window.dataLayer.push(value);
}
